import React from 'react';
import { useHistory } from 'react-router-dom';
import useAppContext from 'flow/hooks/useAppContext';
import useNavigationMenu from 'flow/hooks/useNavigationMenu';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';
import Divider from './Divider';
import Icon from './Icon';
import MenuItem from './MenuItem';

const ToolbarAvatar = () => {
    const { i18next } = useAppContext();
    const { config, navigateToAdminPortal, goToStatsInsights, logOut } =
        useNavigationMenu();

    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);

    const history = useHistory();

    return (
        <>
            <MenuItem
                className="px-3"
                onClick={() =>
                    history.push(
                        generatePath(routes['settings.account'], {
                            extensionKey: ownExtensionKey,
                        }),
                    )
                }
            >
                <div className="flex items-center gap-2">
                    <span className="text-sm">
                        {i18next.t('Settings.Account')}
                    </span>
                </div>
            </MenuItem>

            <Divider className="my-2" />

            {config.shouldShowAdminPortal && (
                <MenuItem onClick={navigateToAdminPortal}>
                    <Icon
                        iconKey="openInNew"
                        className="me-2 text-gray-600 rtl:scale-x-[-1]"
                    />
                    <span className="text-sm">
                        {i18next.t('settings.to.flow')}
                    </span>
                </MenuItem>
            )}

            {config.shouldShowStats && (
                <MenuItem onClick={goToStatsInsights}>
                    <Icon
                        iconKey="openInNew"
                        className="me-2 text-gray-600 rtl:scale-x-[-1]"
                    />
                    <span className="text-sm">
                        {i18next.t('settings.to.stats')}
                    </span>
                </MenuItem>
            )}

            {config.shouldShowLogOut && (
                <MenuItem onClick={() => logOut('Toolbar Avatar')}>
                    <Icon iconKey="logOut" className="me-2 text-gray-600" />

                    <span className="text-sm">{i18next.t('app.signout')}</span>
                </MenuItem>
            )}
        </>
    );
};

export default ToolbarAvatar;
